import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from '@reduxjs/toolkit/query'
import authReducer from './Slice/auth'
import loadingReducer from './Slice/loading'
import { authApi } from "./Api/login";
import { stateApi } from "./Api/state";
import { contactApi } from "./Api/contact";
import { productApi } from "./Api/product";
import productReducer from "./Slice/products"
import uiReducer from "./Slice/ui"

export const store = configureStore({
    reducer: {
        auth: authReducer,
        products: productReducer,
        loading: loadingReducer,
        ui: uiReducer,
        [authApi.reducerPath]: authApi.reducer,
        [stateApi.reducerPath]: stateApi.reducer,
        [contactApi.reducerPath]: contactApi.reducer,
        [productApi.reducerPath]: productApi.reducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat([authApi.middleware, stateApi.middleware, contactApi.middleware, productApi.middleware]),
});

setupListeners(store.dispatch)

